import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { PetitionTypes } from '../../models/petition-types';
import { PetitionProvider } from '../../providers/petition/petition';


@IonicPage()
@Component({
  selector: 'page-petition-hour-compensation',
  templateUrl: 'petition-hour-compensation.html',
})
export class PetitionHourCompensationPage {

  petition: any = {};
  
  maxPeriod: number;
  minPeriod: number;
  
  constructor(
    private loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public petitionProvider: PetitionProvider,
    public globalVars: GlobalVars,
  ) {
    this.maxPeriod = this.globalVars.currentPeriod + 1;
    this.minPeriod = this.globalVars.currentPeriod - 1;
  }

  send() {
    if (this.checkData()) {
      if (this.globalVars.user.extraHours >= this.petition.compensationHours) {

        this.petition.user = this.globalVars.user.name;
        this.petition.userKey = this.globalVars.user.key;
        this.petition.type = 'Compensación de horas extra';
        this.petition.typeId = PetitionTypes.hourCompensation;
        this.petition.comments = this.petition.comments ? this.petition.comments : ' ';
        this.petition.area = this.globalVars.user.area;
        this.petition.areaId = this.globalVars.user.areaId;
        this.petition.state = this.globalVars.user.areaId;
        this.petition.stateName = this.globalVars.user.area;
        this.petition.annulment = false;
        this.petition.annulmentSended = false;
        this.petition.creationDate = new Date().getTime();
        this.petition.mailbox = false;
        this.petition.process = 'flow';
        
        console.log(this.petition)

        let loading = this.loadingCtrl.create();
        loading.present()

        this.petitionProvider.addPetition(this.petition)
        .then(msg => {
          loading.dismiss()
          this.showMessage(msg)
          this.navCtrl.pop();
        })
        
        .catch(error => {
          loading.dismiss()
          this.showMessage(error)
        })
      }

      else this.showMessage(`No tiene suficientes horas extra para compensar.`);
    }

    else this.showMessage(`Introduzca todos los datos.`);
  }

  private checkData() {
    return this.petition.beginDate && this.petition.endDate && this.petition.compensationHours;
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/petition-hour-compensation/petition-hour-compensation.ts